import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Divider, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Stack } from '@mui/material';
import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import imgDefault from './upload.png';
import axios from 'axios';
import InputGroupProperty from '../Input/InputGroupProperty';
import ComboBox from '../Input/ComboBox';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const StyledProductImg = styled('img')({
    // top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // position: 'absolute',
});
const GroupDeviceModal = ({ visible = false, dataUpdate, setVisible, fuctGet, idPermission, isEdit }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [name, setName] = useState('');
    const [code, setcode] = useState('');
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addCabinetFlag = useRef(false);
    const [blob, setBlob] = useState('');
    const [imgEdit, setImgEdit] = useState('');
    const [property, setProperty] = useState([]);
    const imageName = useRef('');
    const dataReqImg = useRef({
        imgType: '',
        image_data: '',
        size: 0,
        encodeType: null,
    });
    const arrOptions = [
        { label: t('borrowing'), value: '0' },
        { label: t('take'), value: '1' },
        { label: t('mixed'), value: '2' },
    ];
    const [option, setOption] = useState(arrOptions[2]);
    const [blobProperties, setBlobProperties] = useState('');
    const [imgEditProperties, setImgEditProperties] = useState('');
    const imagePropertiesName = useRef('');
    const dataReqImgProperties = useRef({
        imgType: '',
        image_data: '',
        size: 0,
        encodeType: null,
    });

    useEffect(() => {
        console.log('dataUpdate', dataUpdate);

        imageName.current = dataUpdate.pic_device;
        imagePropertiesName.current = dataUpdate.pic_properties_device;
        if (isEdit) {
            setBlob('');
            setBlobProperties('');
            setName(dataUpdate.group_nm);
            setProperty(dataUpdate.group_properties);
            setcode(dataUpdate.group_cd);
            setImgEdit(dataUpdate.pic_device);
            imageName.current = dataUpdate.pic_device;
            setImgEditProperties(dataUpdate.pic_properties_device);
            imagePropertiesName.current = dataUpdate.pic_properties_device;
            setOption(arrOptions.filter((row) => row.value === dataUpdate.type)[0] || null);
        } else {
            setName('');
            setcode('');
            setProperty([]);
            setBlob('');
            setImgEdit('');
            imageName.current = '';
            setBlobProperties('');
            setImgEditProperties('');
            imagePropertiesName.current = '';
            setOption(arrOptions[2]);
        }
        setFileToUpload(null);
        setBlob('');
        setFileToUploadProperties(null);
        setBlobProperties('');
    }, [dataUpdate]);

    const [fileToUpload, setFileToUpload] = useState(null);
    const [fileToUploadProperties, setFileToUploadProperties] = useState(null);

    const handleOnChangeFile = async (e) => {
        let file = e.target.files[0];
        if (!file) return;
        if (file.size > 50 * 1024 * 1024) {
            toast.error(t('error.file_too_large'));
            return;
        }
        setFileToUpload(file);
        try {
            const url = URL.createObjectURL(file);
            setBlob(url);
        } catch (err) {
            console.error('Error creating object URL:', err);
        }
    };

    const handleOnChangeFileProperties = async (e) => {
        let file = e.target.files[0];
        if (!file) return;
        if (file.size > 50 * 1024 * 1024) {
            toast.error(t('error.file_too_large'));
            return;
        }
        setFileToUploadProperties(file);
        try {
            const url = URL.createObjectURL(file);
            setBlobProperties(url);
        } catch (err) {
            console.error('Error creating object URL:', err);
        }
    };

    const handleAddReport = async () => {
        if (addCabinetFlag.current) return;
        if (!property) return toast.error(t('please_add_property'));
        if (!name || !code || !property || !option?.value) return toast.error(t('error.param'));

        addCabinetFlag.current = true;
        setFlagAddStat(true);

        try {
            if (fileToUpload) {
                const reader = new FileReader();
                const imageData = await new Promise((resolve, reject) => {
                    reader.onload = (evt) =>
                        resolve(evt.target.result.toString().replace(/^data:image\/\w+;base64,/, ''));
                    reader.onerror = (err) => reject(err);
                    reader.readAsDataURL(fileToUpload);
                });

                const req = await axios.post(`${glb_sv.urlPostProductImage}`, {
                    imgType: fileToUpload.type.slice(6),
                    image_data: imageData,
                    size: fileToUpload.size,
                    encodeType: 'base64',
                });
                if (req?.data?.success) {
                    imageName.current = req.data.data.imageName;
                } else {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }
            }
            if (fileToUploadProperties) {
                const reader = new FileReader();
                const imageData = await new Promise((resolve, reject) => {
                    reader.onload = (evt) =>
                        resolve(evt.target.result.toString().replace(/^data:image\/\w+;base64,/, ''));
                    reader.onerror = (err) => reject(err);
                    reader.readAsDataURL(fileToUploadProperties);
                });

                const req = await axios.post(`${glb_sv.urlPostProductImage}`, {
                    imgType: fileToUploadProperties.type.slice(6),
                    image_data: imageData,
                    size: fileToUploadProperties.size,
                    encodeType: 'base64',
                });
                if (req?.data?.success) {
                    imagePropertiesName.current = req.data.data.imageName;
                } else {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }
                if (!imagePropertiesName.current || imagePropertiesName.current === '') {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }
            }

            if (fileToUpload) {
                if (!imageName.current || imageName.current === '') {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }
            }

            if (isEdit) {
                const InVal = [
                    +idPermission,
                    imageName.current,
                    code,
                    name,
                    JSON.stringify(property),
                    dataUpdate.id,
                    imagePropertiesName.current,
                    option.value,
                ];
                sendRequest(serviceList.updategroup_devices, InVal, actionResult, true, timeOutFunct, 40000);
            } else {
                const InVal = [
                    +idPermission,
                    imageName.current,
                    code,
                    name,
                    JSON.stringify(property),
                    imagePropertiesName.current,
                    option.value,
                ];
                sendRequest(serviceList.creategroup_devices, InVal, actionResult, true, timeOutFunct, 40000);
            }
        } catch (error) {
            console.error('Upload error:', error);
            toast.error(t('error.system_error'));
            setFlagAddStat(false);
            addCabinetFlag.current = false;
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();

            setVisible(!visible);
        }
    };
    const timeOutFunct = (reqInfo) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            // style={{ minWidth: '650px', width: '100%' }}
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <Loader loading={flagAddStat} />
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {isEdit ? t('upadte_group_devices') : t('add_group_devices')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    {' '}
                    <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                        <TextInput
                            label={t('name_group_devices')}
                            valueChange={name}
                            getValue={setName}
                            required
                            autoFocus
                        />
                    </Grid>
                    <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('code_group_devices')} valueChange={code} required getValue={setcode} />
                    </Grid>
                    <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('status_device')}
                            selectOption={arrOptions}
                            valueSelect={option}
                            required
                            getValue={setOption}
                        />
                    </Grid>
                    <InputGroupProperty isCustom getValue={setProperty} valueChange={property} />
                    {/* <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('choose_group_property')}
                            valueChange={nameRepresent}
                            getValue={setNameRepresent}
                        />
                    </Grid>{' '}
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput
                            label={t('enter_group_property')}
                            valueChange={valueProperty}
                            getValue={setValueProperty}
                        />
                    </Grid> */}
                    <Grid item xl={6} md={6} sm={6} style={{ width: '100%' }} display={'flex'} justifyContent={'left'}>
                        <input
                            type="file"
                            name="upload"
                            accept="image/png,image/jpg,image/jpeg"
                            onChange={handleOnChangeFile}
                            id="upload"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="upload" className={'upload-img-report col-form-label'}>
                            <span style={{ color: '#888', fontSize: '14px' }}>{t('img_group')} </span>
                            <Stack direction="row" spacing={2}>
                                {isEdit && !blob ? (
                                    <img src={`${glb_sv.urlGetProductImage(imgEdit)}`} alt="" />
                                ) : (
                                    <img src={blob ? blob : imgDefault} alt="" />
                                )}
                            </Stack>
                        </label>
                    </Grid>
                    <Grid item xl={6} md={6} sm={6} style={{ width: '100%' }} display={'flex'} justifyContent={'left'}>
                        <input
                            type="file"
                            name="uploadImgProperties"
                            accept="image/png,image/jpg,image/jpeg"
                            onChange={handleOnChangeFileProperties}
                            id="uploadImgProperties"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="uploadImgProperties" className={'upload-img-report col-form-label'}>
                            <span style={{ color: '#888', fontSize: '14px' }}>{t('img_properties')} </span>
                            <Stack direction="row" spacing={2}>
                                {isEdit && !blobProperties ? (
                                    <img
                                        src={
                                            imgEditProperties
                                                ? `${glb_sv.urlGetProductImage(imgEditProperties)}`
                                                : imgDefault
                                        }
                                        alt=""
                                    />
                                ) : (
                                    <img src={blobProperties ? blobProperties : imgDefault} alt="" />
                                )}
                            </Stack>
                        </label>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    disabled={flagAddStat}
                    onClick={() => {
                        setVisible(!visible);
                        setFileToUpload(null);
                        setBlob('');
                        setFileToUploadProperties(null);
                        setBlobProperties('');
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />

                <ButtonAction disabled={flagAddStat} onClick={handleAddReport} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default GroupDeviceModal;
